import auth0 from "auth0-js"
let webAuth0 = new auth0.WebAuth({
	domain: "dev-ayzgkh29.eu.auth0.com",
	clientID: "LUKjyFm4nZm6SwtTSv4Ocv8sb5hYWMkG",
	responseType: "token id_token",
	redirectUri: window.location.origin + "/callback"
})

let config = {
	emailsupport:"support@vsni.co.uk",
	s3: {
		bucket: "biosci-production-mma2",
		region: "eu-west-2"
	},
	SES: {
		REGION: "us-west-2"
	},
	ga: {
		id: "UA-135456763-1"
	},
	appsyncunAuth: {
		graphqlEndpoint:
			"https://fr6jsyl7szaaxkyyrd7jda3dzy.appsync-api.eu-west-2.amazonaws.com/graphql",
		region: "eu-west-2",
		authenticationType: "API_KEY",
		apiKey: "da2-xvzah4tqofavjfsojqco3e2kca"
	},
	appsyncAuth: {
		graphqlEndpoint:
			"https://6hb5whqyq5dw5iplwrn3otj4yu.appsync-api.eu-west-2.amazonaws.com/graphql",
		region: "eu-west-2",
		authenticationType: "AWS_IAM"
	},
	auth: {
		identityPoolId: "ap-southeast-1:40d9077e-1f81-4b06-89eb-923f1c22e77c",
		region: "ap-southeast-1",
		userPoolId: "ap-southeast-1_cic4iDVRg",
		userPoolWebClientId: "4gv70m57g7d5g2kh9pol85gd8f",
		mandatorySignIn: true,
		refreshHandlers: {
			"dev-ayzgkh29.eu.auth0.com": () =>
				new Promise((res, rej) => {
					webAuth0.renewAuth(
						{
							domain: "dev-ayzgkh29.eu.auth0.com",
							clientID: "LUKjyFm4nZm6SwtTSv4Ocv8sb5hYWMkG",
							responseType: "token id_token"
						},
						(err, data) => {
							if (err) {
								rej(err)
							}
							res(data)
						}
					)
				})
		},
		social: {
			FB: "540123446725115",
			GM:
				"32423559507-du6k6e8khk5if6gmulmhs69av6qdkvdl.apps.googleusercontent.com",
			webAuth0,
			openid: "dev-ayzgkh29.eu.auth0.com"
		}
	}
}
export default config
